import '@hotwired/turbo-rails';
import Coloris from '@melloware/coloris';
import './components';

import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

document.addEventListener('turbo:load', () => {
  Coloris.init();
});

let ssoSiteUserId = null;
document.addEventListener('turbo:load', (event) => {
  const siteHost = (document.querySelector('meta[name="site-host"]') as HTMLMetaElement)?.content;
  const siteUserId = (document.querySelector('meta[name="site-user-id"]') as HTMLMetaElement)
    ?.content;
  const siteUserSSOToken = (
    document.querySelector('meta[name="site-user-sso-token"]') as HTMLMetaElement
  )?.content;

  if (siteUserId && ssoSiteUserId != siteUserId) {
    const img = document.createElement('img');
    const port = window.location.port ? `:${window.location.port}` : '';
    img.src = `//${siteHost}${port}/users/sso?token=${siteUserSSOToken}`;
    img.style.display = 'none';
    img.setAttribute('data-turbo-temporary', 'true');
    document.body.appendChild(img);
    ssoSiteUserId = siteUserId;
  }
});
